import Vue from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import config from './config';

Vue.use(VueAxios, axios)

import ElementUI from 'element-ui';
import {localStorageManage} from "@/common/localStorage/localStorageManage";
import router from "@/router/router";

export default function $axios(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: config.baseUrl,
            headers: config.headers,
            timeout: config.timeout,
            // withCredentials: config.withCredentials
        })

        // request 拦截器
        instance.interceptors.request.use(
            config => {
                // let token = Cookies.get('token')
                let token = localStorage.getItem(localStorageManage.token)
                // 1. 请求开始的时候可以结合 vuex 开启全屏 loading 动画
                // 2. 带上token
                if (token) {
                    // config.headers.token = token
                    // config.headers['token'] = 'test' + token + "test";
                    config.headers['token'] = token;
                } else {
                    // 重定向到登录页面
                    // router.push('/login')
                }
                // 3. 根据请求方法，序列化传来的参数，根据后端需求是否序列化
                if (config.method === 'post') {
                    // if (config.data.__proto__ === FormData.prototype
                    //   || config.url.endsWith('path')
                    //   || config.url.endsWith('mark')
                    //   || config.url.endsWith('patchs')
                    // ) {
                    // } else {
                    // config.data = qs.stringify(config.data)
                    // }
                }
                return config
            },

            error => {
                // 请求错误时
                // console.log('request:', error)
                // 1. 判断请求超时
                if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
                    // console.log('timeout请求超时')
                    // return service.request(originalRequest);// 再重复请求一次
                }
                // 2. 需要重定向到错误页面
                const errorInfo = error.response
                // console.log(errorInfo)
                if (errorInfo) {
                    error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
                    const errorStatus = errorInfo.status; // 404 403 500 ...
                    //   router.push({
                    //     path: `/error/${errorStatus}`
                    //   })
                }
                return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
            }
        )

        // response 拦截器
        instance.interceptors.response.use(
            response => {
                //  // 在这里对响应数据进行处理
                //  const { code, msg, data } = response.data;
                //  // 创建一个新的对象，包含 code、msg 和 data 字段
                //  const formattedResponse = { code, msg, data };
                //  return formattedResponse;
                let data;
                // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
                if (response.data === undefined) {
                    data = JSON.parse(response.request.responseText)
                } else {
                    data = response.data
                }
                //console.log(data)
                return data;
                // if (data.code == 401) {  //登录失效
                //   Cookies.remove('token')
                //   //   router.push({
                //   //     path: `/login`
                //   //   })
                // }
                // 根据返回的code值来做不同的处理
                // switch (data.rc) {
                //   case 1:
                //     console.log(data.desc)
                //     break;
                //   case 0:
                //     store.commit('changeState')
                //     // console.log('登录成功')
                //     break;
                //   default:
                // }
                // 若不是正确的返回code，且已经登录，就抛出错误
                // const err = new Error(data.desc)
                // err.data = data
                // err.response = response
                // throw err
            },
            err => {
                if (err && err.response) {
                    switch (err.response.status) {
                        case 400:
                            err.message = '请求错误'
                            break
                        case 401:
                            err.message = '未授权，请登录'
                            break
                        case 403:
                            err.message = '拒绝访问'
                            break
                        case 404:
                            err.message = `请求地址出错: ${err.response.config.url}`
                            break
                        case 408:
                            err.message = '请求超时'
                            break
                        case 500:
                            err.message = '服务器内部错误'
                            break
                        case 501:
                            err.message = '服务未实现'
                            break
                        case 502:
                            err.message = '网关错误'
                            break
                        case 503:
                            err.message = '服务不可用'
                            break
                        case 504:
                            err.message = '网关超时'
                            break
                        case 505:
                            err.message = 'HTTP版本不受支持'
                            break
                        default:
                    }
                }
                // console.error(err)
                return Promise.reject(err) // 返回接口返回的错误信息
            }
        )

        // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

        // 请求处理
        instance(options).then(res => {
            var temp = JSON.stringify(res);
            var data = JSON.parse(temp);
            //console.log(options)
            //统一处理code
            if (data.code === 0) {
                resolve(res)
            } else {
                ElementUI.Message(
                    {
                        message: data.msg == null ? '请求异常' : data.msg,
                        type: 'error'
                    }
                )
                // 40101 未登录/token无效；40102 token过期
                const tokenInvalid = data.code === 40101 || data.code === 40102
                    || data.msg === 'token无效' || data.msg === 'token过期';
                let token = localStorage.getItem(localStorageManage.token) || '';
                if (tokenInvalid && token !== '') {
                    localStorage.removeItem(localStorageManage.token)
                    router.push('/login').then()
                }
            }
            return false
        }).catch(error => {
            reject(error)
        })
    })
}

